module.exports = __webpack_public_path__ + "img/23.1cf41202.png";